(() => {
  const ROOT_SELECTOR = "[data-header-predictive-search]";
  const MIN_QUERY_LENGTH = 2;
  const RESULTS_LIMIT = 6;
  const SEARCH_TERM_GROUPS = [
    ["akcesorium", "akcesoria"],
    ["bateria", "baterie"],
    ["bestseller", "bestsellery"],
    ["biurko", "biurka"],
    ["biuro", "biura"],
    ["but", "buty"],
    ["dziecko", "dzieci", "dziecka"],
    ["dzień", "dni"],
    ["domek", "domki"],
    ["drewno", "drewna"],
    ["drzwi", "drzwiami"],
    ["fotel", "fotele"],
    ["funkcja", "funkcje", "funkcją"],
    ["garderoba", "garderoby"],
    ["grill", "grille"],
    ["jadalnia", "jadalnie", "jadalni"],
    ["kinkiet", "kinkiety"],
    ["komoda", "komody"],
    ["krzesło", "krzesła"],
    ["książka", "książki"],
    ["kuchnia", "kuchnie", "kuchni"],
    ["lampa", "lampy"],
    ["leżak", "leżaki"],
    ["litera", "litery", "literę"],
    ["lustro", "lustra", "lustrem"],
    ["ława", "ławy"],
    ["łazienka", "łazienki"],
    ["łóżko", "łóżka", "łóżku"],
    ["materac", "materace"],
    ["mama", "mamy"],
    ["mebel", "meble", "mebli"],
    ["ogród", "ogrody"],
    ["panel", "panele"],
    ["płyta", "płyty"],
    ["pokój", "pokoje"],
    ["produkt", "produkty"],
    ["promocja", "promocje"],
    ["pralka", "pralki", "pralkę"],
    ["przedpokój", "przedpokoje", "przedpokoju"],
    ["półka", "półki"],
    ["regał", "regały"],
    ["rozmiar", "rozmiary"],
    ["salon", "salony", "salonu"],
    ["seria", "serie"],
    ["siedzisko", "siedziska", "siedziskiem"],
    ["sofa", "sofy"],
    ["spanie", "spania"],
    ["spiżarnia", "spiżarnie"],
    ["stelaż", "stelaże"],
    ["stół", "stoły", "stołu"],
    ["stolik", "stoliki"],
    ["sypialnia", "sypialnie", "sypialni"],
    ["szafa", "szafy"],
    ["szafka", "szafki", "szafkę"],
    ["szuflada", "szuflady", "szufladami"],
    ["telewizor", "telewizory"],
    ["toaletka", "toaletki"],
    ["umywalka", "umywalki", "umywalkę"],
    ["wieszak", "wieszaki", "wieszakiem"],
    ["witryna", "witryny"],
    ["zestaw", "zestawy"],
    ["zlew", "zlewy"],
    ["żywica", "żywice", "żywicy"],
    ["biały", "biała", "białe"],
    ["biurowy", "biurowa", "biurowe"],
    ["czarny", "czarna", "czarne"],
    ["dziecięcy", "dziecięca", "dziecięce"],
    ["dolny", "dolna", "dolne"],
    ["drewniany", "drewniana", "drewniane"],
    ["epoksydowy", "epoksydowa", "epoksydowe", "epoksydowej"],
    ["gamingowy", "gamingowa", "gamingowe"],
    ["granitowy", "granitowa", "granitowe"],
    ["kawowy", "kawowa", "kawowe"],
    ["komorowy", "komorowa", "komorowe"],
    ["kontynentalny", "kontynentalna", "kontynentalne"],
    ["kuchenny", "kuchenna", "kuchenne"],
    ["kwadratowy", "kwadratowa", "kwadratowe"],
    ["łazienkowy", "łazienkowa", "łazienkowe", "łazienkowych"],
    ["lity", "lita", "lite", "litego"],
    ["magazynowy", "magazynowa", "magazynowe"],
    ["metalowy", "metalowa", "metalowe"],
    ["młodzieżowy", "młodzieżowa", "młodzieżowe"],
    ["nablatowy", "nablatowa", "nablatowe"],
    ["narożny", "narożna", "narożne"],
    ["nocny", "nocna", "nocne"],
    ["ogrodowy", "ogrodowa", "ogrodowe", "ogrodowych"],
    ["okrągły", "okrągła", "okrągłe"],
    ["otwarty", "otwarta", "otwarte"],
    ["podłogowy", "podłogowa", "podłogowe"],
    ["przesuwny", "przesuwna", "przesuwne"],
    ["rozkładany", "rozkładana", "rozkładane"],
    ["stalowy", "stalowa", "stalowe"],
    ["stołowy", "stołowa", "stołowe"],
    ["ścienny", "ścienna", "ścienne"],
    ["tapicerowany", "tapicerowana", "tapicerowane"],
    ["warsztatowy", "warsztatowa", "warsztatowe"],
    ["wąski", "wąska", "wąskie"],
    ["wiszący", "wisząca", "wiszące"],
    ["wysoki", "wysoka", "wysokie"]
  ];
  const SEARCH_TERM_VARIANTS = new Map();

  SEARCH_TERM_GROUPS.forEach((group) => {
    group.forEach((term) => SEARCH_TERM_VARIANTS.set(term.toLocaleLowerCase("pl-PL"), group));
  });

  function debounce(callback, delay) {
    let timeoutId;

    return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => callback(...args), delay);
    };
  }

  function buildStrictProductQuery(value) {
    const trimmedValue = value.trim();

    if (!trimmedValue || trimmedValue.includes('title:"')) return trimmedValue;

    const terms = trimmedValue.split(/\s+/).filter(Boolean);

    return terms.map((term) => {
      const normalizedTerm = term.toLocaleLowerCase("pl-PL");
      const mappedVariants = SEARCH_TERM_VARIANTS.get(normalizedTerm) || [];
      const variants = [term, ...mappedVariants.filter((variant) => variant !== normalizedTerm)];
      const clauses = [...new Set(variants)].map((variant) => {
        const escapedVariant = variant.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
        return `title:"${escapedVariant}"`;
      });

      return clauses.length > 1 ? `(${clauses.join(" OR ")})` : clauses[0];
    }).join(" ");
  }

  function initStrictSearchForms() {
    document.querySelectorAll("[data-strict-product-search]").forEach((form) => {
      if (form.dataset.strictSearchReady === "true") return;

      const input = form.querySelector("input[name='q']");
      if (!input) return;

      form.dataset.strictSearchReady = "true";
      form.addEventListener("submit", (event) => {
        const visibleQuery = input.value.trim();
        const strictQuery = buildStrictProductQuery(visibleQuery);

        if (!visibleQuery || strictQuery === visibleQuery) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const searchUrl = new URL(
          `${window.Shopify?.routes?.root || "/"}search`,
          window.location.origin
        );
        searchUrl.searchParams.set("q", strictQuery);
        searchUrl.searchParams.set("type", "product");
        window.location.assign(searchUrl);
      });
    });
  }

  function init(root) {
    if (root.dataset.predictiveSearchReady === "true") return;

    const form = root.querySelector("[data-header-search-form]");
    const input = root.querySelector("[data-header-search-input]");
    const results = root.querySelector("[data-header-search-results]");

    if (!form || !input || !results) return;

    root.dataset.predictiveSearchReady = "true";

    const cache = new Map();
    let requestController;

    function closeResults() {
      results.hidden = true;
      results.removeAttribute("aria-busy");
      input.setAttribute("aria-expanded", "false");
    }

    function openResults() {
      results.hidden = false;
      input.setAttribute("aria-expanded", "true");
    }

    function renderEmpty() {
      results.innerHTML = '<p class="header__desktop-search-empty">Brak wyników.</p>';
      openResults();
    }

    function renderProducts(documentResult) {
      const productList = documentResult.querySelector(
        ".predictive-search__result-row--products"
      );

      if (!productList || !productList.children.length) {
        renderEmpty();
        return;
      }

      const renderedList = productList.cloneNode(true);
      renderedList.removeAttribute("id");
      renderedList.classList.remove("visually-hidden");
      renderedList.classList.add("is-active");

      results.replaceChildren(renderedList);
      openResults();
    }

    async function search() {
      const query = input.value.trim();

      if (query.length < MIN_QUERY_LENGTH) {
        requestController?.abort();
        results.replaceChildren();
        closeResults();
        return;
      }

      const cacheKey = query.toLocaleLowerCase();

      if (cache.has(cacheKey)) {
        renderProducts(cache.get(cacheKey));
        return;
      }

      requestController?.abort();
      requestController = new AbortController();
      results.setAttribute("aria-busy", "true");
      openResults();

      const rootUrl = window.Shopify?.routes?.root || "/";
      const strictQuery = buildStrictProductQuery(query);
      const params = new URLSearchParams({
        q: strictQuery,
        "resources[type]": "product",
        "resources[limit]": String(RESULTS_LIMIT),
        section_id: "predictive-search"
      });

      try {
        const response = await fetch(`${rootUrl}search/suggest?${params}`, {
          signal: requestController.signal,
          headers: { Accept: "text/html" }
        });

        if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);

        const responseDocument = new DOMParser().parseFromString(
          await response.text(),
          "text/html"
        );

        cache.set(cacheKey, responseDocument);
        renderProducts(responseDocument);
      } catch (error) {
        if (error.name !== "AbortError") closeResults();
      } finally {
        results.removeAttribute("aria-busy");
      }
    }

    input.addEventListener("input", debounce(search, 200));

    input.addEventListener("focus", () => {
      if (input.value.trim().length >= MIN_QUERY_LENGTH && results.children.length) {
        openResults();
      }
    });

    root.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeResults();
        input.focus();
        return;
      }

      if (event.key === "ArrowDown" && event.target === input && !results.hidden) {
        const firstResult = results.querySelector("a");
        if (firstResult) {
          event.preventDefault();
          firstResult.focus();
        }
      }
    });

    form.addEventListener("submit", (event) => {
      if (!input.value.trim()) event.preventDefault();
    });

    document.addEventListener("pointerdown", (event) => {
      if (!root.contains(event.target)) closeResults();
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
    initStrictSearchForms();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
